import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import RouterMixin from '@/apps/assessment/mixins/router-mixin'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import AssessmentMenu from '../components/assessment-menu'

@Component({ components: { AssessmentMenu, BasicLayout } })
export default class MyAssessment extends Vue {
    private get isClazz() {
        return this.$route.meta.isClazz
    }
}
